import { Injectable } from '@angular/core';
import { Observable, of, zip } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { ContractService } from '../services/contract.service';
import { Transaction } from '../transaction/transaction';
import { TransferProvider } from '../providers/transfer-provider.service';
import { UseCase } from './common/use.case';
import { ValidModelInterface } from '../data';

@Injectable()
export class GetValidModelsUseCase implements UseCase<Observable<Transaction<ValidModelInterface[]>>> {
    constructor(
        private contractProvider: ContractProvider,
        private contractService: ContractService,
        private transferProvider: TransferProvider
    ) {}

    bind(): Observable<Transaction<ValidModelInterface[]>> {
        return zip(this.contractProvider.current(), this.contractService.getAppropriatenessClient()).pipe(
            switchMap((transactions) => {
                if (!transactions[0].isSuccess || !transactions[1].isSuccess) {
                    return of(Transaction.error<ValidModelInterface[]>(transactions[0].error || transactions[1].error));
                } else {
                    const contract = transactions[0].data;
                    const appropriatenessClient = transactions[1].data;

                    return this.transferProvider.getValidModels(contract, appropriatenessClient);
                }
            })
        );
    }
}
